/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dashboard-background[_ngcontent-%COMP%]{position:relative;min-height:100vh;background-image:url(BgCandidatDashboard.6ddeab2686f5b81533eb.jpg);background-position-x:center;background-position-y:center;background-size:cover;background-attachment:fixed}.dashboard[_ngcontent-%COMP%]   .mat-card[_ngcontent-%COMP%]{margin-bottom:.5rem!important}"];
export { styles as styles };
